import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { Confirm } from 'react-confirm-bootstrap';
import { MenuItem } from 'react-bootstrap/lib';
import withFeedPermission from './feedPermission';

function DeleteButton({ feed, onDelete }) {
  return (
    <Confirm
      onConfirm={() => onDelete(feed.id)}
      body={`Are you sure you want to delete ${feed.name}?`}
      confirmText="Confirm Delete"
      title={`Deleting ${feed.name}`}
    >
      <MenuItem>Delete</MenuItem>
    </Confirm>
  );
}

DeleteButton.propTypes = {
  feed: PropTypes.object,
  onDelete: PropTypes.func,
};

export default withFeedPermission(Permissions.DELETE)(DeleteButton);
